import axios from "axios";
import CryptoJS from "crypto-js";

export default {
    install(Vue) {
        //------------------------------------------[[ function ]]-------------------------------------------

        // 로그 출력
        Vue.prototype.$PrintLog = function (_log) {
            console.log(_log);
            return true;
        };

        // 페이지 이동
        Vue.prototype.$PageMove = function (_url) {

            // dimm 보임 처리
            this.$ShowDimmLogo(() => {

                var max = 99;
                var min = 10
                var ran = Math.floor(Math.random() * (max - min) + min);

                var arrURL = _url.split("?");

                var arrQS = [];
                if (arrURL.length > 1) {
                    arrQS = arrURL[1].split("&");
                }

                var url = arrURL[0] + "?";

                var sharp = '';
                for (var idx = 0; idx < arrQS.length; idx++) {
                    if (idx > 0) {
                        url += "&";
                    }

                    var _arrQS = arrQS[idx].split("#");
                    sharp = _arrQS[1];
                    url += _arrQS[0];
                }
                url += "&rd=" + ran;

                if (sharp) {
                    url += "#" + sharp;
                }

                url = url.replace("?&", "?");

                // 이동
                this.$router.push(url).catch(() => {
                    this.$HideDimmLogo();
                });

            });

            return true;
        };

        // dimm 보임 처리
        Vue.prototype.$ShowDimmLogo = function (_fnc) {
            var $dimm_logo = $("#dev_dimm_logo").stop(true, false);
            var done = false;
            var run = function () { if (!done) { done = true; _fnc && _fnc(); } };
            $dimm_logo.fadeIn(300, run);
            setTimeout(run, 400); // 애니메이션이 중단돼도 콜백 보장
            return true;
        };

        // dimm 숨김 처리
        Vue.prototype.$HideDimmLogo = function (_fnc) {
            $("#dev_dimm_logo").stop(true, true).fadeOut(500, _fnc);
            return true;
        };

        // 엔터
        Vue.prototype.$SetEventEnter = function (_name, _fnc) {

            $("[name='" + _name + "']").on("keydown", function (e) {

                if (e.keyCode === 13) {

                    e.preventDefault();

                    if (_fnc) {
                        _fnc();
                    }
                }
            });

            return true;
        };

        // AfterMounted
        Vue.prototype.$AfterMounted = function (Vue) {

            // 페이징 function 세팅
            Vue.getRowNum = function (idx) {
                return Vue.rownum - idx;
            };

            // form 안의 enter 키 클릭시 검색
            $(document).off("keydown", "[name='search_text']");
            $(document).on("keydown", "[name='search_text']", function (e) {

                if (e.keyCode === 13) {

                    e.preventDefault();
                    Vue.getSearchData(1);
                }
            });

            //옵션 체크시 자동 검색
            $(document).off("click", ".dev_option :checkbox");
            $(document).on("click", ".dev_option :checkbox", function () {

                Vue.getSearchData(1);

            });

            // 검색버튼 클릭시
            $(document).off("click", ".dev_btn_search");
            $(document).on("click", ".dev_btn_search", function () {

                Vue.getSearchData(1);

            });

            // 저장버튼 클릭시
            $(document).off("click", ".dev_btn_submit");
            $(document).on("click", ".dev_btn_submit", function () {

                Vue.saveData();

            });

            // 삭제버튼 클릭시
            $(document).off("click", ".dev_btn_delete");
            $(document).on("click", ".dev_btn_delete", function () {

                Vue.deleteData();

            });

            // 첫 데이터 조회
            Vue.init(Vue);

        };

        // AfterMounted
        Vue.prototype.$AfterUpdated = function (Vue) {

            // 첨부파일 확장자에 맞게 이미지 변경
            changeFileItemImg();

        };

        // 쿼리스트링
        Vue.prototype.$GetQueryMap = function () {
            return this.$route.query;
        };

        // form to map 변환
        Vue.prototype.$FormToMap = function ($form) {

            var form = {}

            var $arrEle = [];

            // text
            $arrEle = $.merge($arrEle, $form.find("[type=text]"));

            // hidden
            $arrEle = $.merge($arrEle, $form.find("[type=hidden]"));

            // password
            $arrEle = $.merge($arrEle, $form.find("[type=password]"));

            // radio
            $arrEle = $.merge($arrEle, $form.find("[type=radio]:checked"));

            // checkbox
            $arrEle = $.merge($arrEle, $form.find("[type=checkbox]:checked"));

            // textarea
            $arrEle = $.merge($arrEle, $form.find("textarea"));

            // select
            $arrEle = $.merge($arrEle, $form.find("select"));

            // name 별 value 정리
            $.each($arrEle, function (idx, el) {

                var name = el.name;
                var value = el.value;

                var arr = form[name];
                if (!arr) {                    
                    arr = form[name] = [];
                }

                arr.push(value);
            });

            var arrKey = Object.keys(form);
            for (var idx = 0; idx < arrKey.length; idx++) {

                var arrVal = form[arrKey[idx]];
                form[arrKey[idx]] = arrVal.join(",")
            }

            return form;

            //return $form.serializeObject();
        };

        //------------------------------------------[[ ajax ]]-------------------------------------------

        // Post
        Vue.prototype.$SendPost = function (_url, _data, _func) {

            /*
            _url  : string
            _data : map
            _func : function(data, err)
            */

            // axios 배열
            let arrAxios = [];
            {
                let map = { "URL": _url, "DATA": _data };

                // url 체크
                {
                    if (!map["URL"])
                        map["URL"] = "/vue_api/common/common/default";
                }

                // 헤더
                let hyper_a = "";
                let hyper_b = "";
                let hyper_c = "";
                let hyper_d = "";
                let hyper_e = "";
                let hyper_p = "";
                {
                    // hyper_a
                    {
                        let temp = this.$GetCookie("hyper_a");
                        if (!this.$IsEmpty(temp)) {
                            hyper_a = "Bearer " + temp;
                        }
                    }

                    // hyper_b
                    {
                        let temp = this.$GetCookie("hyper_b");
                        if (!this.$IsEmpty(temp)) {
                            hyper_b = temp;
                        }
                    }

                    // hyper_c
                    {
                        let temp = this.$GetCookie("hyper_c");
                        if (!this.$IsEmpty(temp)) {
                            hyper_c = temp;
                        }
                    }

                    // hyper_d
                    // hyper_e
                    {
                        let _strD = this.$EncBase64(this.$GetRanStrAscii(16));
                        let _json = this.$ToJson(map["DATA"]);

                        let _strE = this.$EncAES256(this.$DecBase64(hyper_c), this.$DecBase64(_strD), _json);


                        hyper_d = this.$EncBase64(_strD.length);
                        hyper_e = _strD + _strE;
                    }

                    // hyper_p
                    {
                        hyper_p = this.$EncBase64(map["DATA"]["gubunProc"]);
                    }

                    //console.log("[send]>>>>>>>>>>>>>>>>>>>>>");
                    //console.log("hyper_a", hyper_a);
                    //console.log("hyper_b", hyper_b);
                    //console.log("hyper_c", hyper_c);
                    //console.log("hyper_d", hyper_d);
                    //console.log("hyper_e", hyper_e);
                    //console.log("hyper_p", hyper_p);
                    //console.log("===========================");
                }

                // 데이터
                let data = { "b": hyper_b, "d": hyper_d, "e": hyper_e, "p": hyper_p };

                // URLSearchParams 객체를 생성하여 데이터를 변환
                const formData = new URLSearchParams();
                for (const key in data) {
                    formData.append(key, data[key]);
                }

                arrAxios.push(
                    axios.post(
                        map["URL"]
                        , formData
                        , {
                            headers: {
                                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                                "Authorization": hyper_a,
                            }
                        }
                    )
                );
            }

            axios.all(arrAxios)
                .then(axios.spread(async (...arrRes) => {

                    for (let idx = 0; idx < arrRes.length; idx++) {

                        let res = arrRes[idx];

                        let _a = this.$ConString(res.data.a); // JWT
                        let _b = this.$ConString(res.data.b); // AES256 시간 키
                        let _c = this.$ConString(res.data.c); // AES256 KEY
                        let _d = this.$ConString(res.data.d); // AES256 IV length
                        let _e = this.$ConString(res.data.e); // AES256 IV + DATA
                        let _p = this.$ConString(res.data.p); // gubunProc

                        if (_a) {
                            this.$SetCookie("hyper_a", _a, 60);
                        }
                        if (_b) {
                            this.$SetCookie("hyper_b", _b, 60);
                        }
                        if (_c) {
                            this.$SetCookie("hyper_c", _c, 60);
                        }

                        let data = null;
                        {
                            let _len = this.$DecBase64(_d);

                            let _cc = this.$GetCookie("hyper_c");
                            let _dd = _e.substring(0, _len);
                            let _ee = _e.substring(_len);

                            let _json = this.$DecAES256(this.$DecBase64(_cc), this.$DecBase64(_dd), _ee);
                            data = this.$FromJson(_json);
                        }

                        let proc = "";
                        {
                            proc = this.$DecBase64(_p);
                        }

                        //console.log("[receive]<<<<<<<<<<<<<<<<<");
                        //console.log("_a", _a);
                        //console.log("_b", _b);
                        //console.log("_c", _c);
                        //console.log("_d", _d);
                        //console.log("_e", _e);
                        //console.log("proc", proc);
                        //console.log("data", data);
                        //console.log("===========================");

                        if (data) {

                            // 에러
                            if (false == this.$IsEmpty(data.RESULT_EXCEPTION)) {
                                console.log("sendPost Err : ", data.RESULT_EXCEPTION);
                            }

                            // 알림
                            if (false == this.$IsEmpty(data.RESULT_ALERT)) {
                                alert(data.RESULT_ALERT);
                            }

                            // 기능
                            if (false == this.$IsEmpty(data.RESULT_FUNC)) {
                                eval(data.RESULT_FUNC);
                            }

                            // 이동
                            if (false == this.$IsEmpty(data.RESULT_URL)) {
                                this.$PageMove(data.RESULT_URL);
                            }
                            else {

                                // 리턴
                                _func(data, false);
                            }
                        }
                    }
                }))
                .catch(async (err) => {

                    console.log("sendPost Err : ", err);

                    const dataStr = typeof err.response?.data === "string"
                        ? err.response.data
                        : JSON.stringify(err.response?.data);

                    // AES256 접근 에러
                    if (500 == err.response?.status && true == dataStr.includes("ERROR_AES256")) {

                        this.$PrintLog("!!!!!!! 500 err aes256");

                        this.$PageMove("/");
                        alert("잘못된 경로로 접근하셨습니다.");
                        return;
                    }

                    // JWT 접근 에러
                    else if (401 == err.response?.status && true == dataStr.includes("ERROR_JWT")) {

                        this.$PrintLog("!!!!!!! 401 err jwt");

                        this.$PageMove("/");
                        alert("잘못된 경로로 접근하셨습니다.");
                        return;
                    }

                    // 그외 에러
                    else {

                        // 리턴
                        _func(false, msg);
                    }
                });

            return true;
        };

        //------------------------------------------[[ conversion ]]-------------------------------------------

        // Empty
        Vue.prototype.$IsEmpty = function (_text_1) {
            if (_text_1 == null || typeof _text_1 == "undefined") {
                return true;
            }
            return _text_1.toString().replace(/\s/g, "").length < 1;
        };

        // IsContains
        Vue.prototype.$IsContains = function (_text_1, _text_2) {
            if (false == this.$IsEmpty(_text_1)
                && _text_1.indexOf(this.$ConString(_text_2)) > -1) {

                return true;
            }
            return false;
        };

        // IsStartWith
        Vue.prototype.$IsStartWith = function (_text_1, _text) {
            return _text_1.startsWith(_text);
        };

        // ConString
        Vue.prototype.$ConString = function (text_1, text_2) {

            if ([0, 1, -1].includes(text_1)
                || ["0", "1", "-1"].includes(text_1)) {

                text_1 = text_1.toString();
            }

            if (this.$IsEmpty(text_1)) {
                text_1 = "";
            }

            if (this.$IsEmpty(text_2)) {
                text_2 = "";
            }

            if (!text_1) {
                text_1 = text_2;
            }

            return text_1.toString().trim();
        };

        // ConMoney
        Vue.prototype.$ConMoney = function (_text_1) {
            return this.$ConInt(_text_1).toLocaleString("ko-KR");
        };

        // ConInt
        Vue.prototype.$ConInt = function (_text_1) {
            let num = parseInt(this.$ConString(_text_1));
            if (isNaN(num)) {
                return 0;
            }
            return num;
        };

        // ConDouble
        Vue.prototype.$ConDouble = function (_text_1) {
            let num = parseFloat(this.$ConString(_text_1));
            if (isNaN(num)) {
                return 0;
            }
            return num;
        };

        // ConYN
        Vue.prototype.$ConYN = function (_text_1) {
            if (_text_1 == "Y" || _text_1 == 1) {
                return "예";
            } else if (_text_1 == "N" || _text_1 == 0) {
                return "아니오";
            } else {
                return "";
            }
        };

        // ConGender
        Vue.prototype.$ConGender = function (_text_1) {
            if (
                _text_1 == "M" ||
                _text_1 == 1 ||
                _text_1 == 3 ||
                _text_1 == 5 ||
                _text_1 == 7 ||
                _text_1 == 9
            ) {
                return "남";
            } else if (
                _text_1 == "F" ||
                _text_1 == 0 ||
                _text_1 == 2 ||
                _text_1 == 4 ||
                _text_1 == 6 ||
                _text_1 == 8
            ) {
                return "여";
            } else {
                return "";
            }
        };

        // ConHtml
        Vue.prototype.$ConHtml = function (_text_1) {
            let _textarea = document.createElement("textarea");
            if (_text_1) {
                _textarea.innerHTML = _text_1;
            }
            return _textarea.childNodes.length === 0
                ? ""
                : _textarea.childNodes[0].nodeValue;
        };

        // ToJson
        Vue.prototype.$ToJson = function (obj) {
            try {
                return JSON.stringify(obj);
            } catch (e) {
                console.warn("Invalid JSON:", e.message);
                return null;
            }
        };

        // FromJson
        Vue.prototype.$FromJson = function (json) {
            try {
                // BOM 제거 (\uFEFF)
                const cleaned = json.replace(/^\uFEFF/, '');
                return JSON.parse(cleaned);
            } catch (e) {
                console.warn("Invalid JSON:", e.message);
                return null;
            }
        };

        // EncBase64
        Vue.prototype.$EncBase64 = function (text) {
            const utf8 = new TextEncoder().encode(text);
            let base64 = btoa(String.fromCharCode(...utf8));
            return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
        };

        // DecBase64
        Vue.prototype.$DecBase64 = function (text) {

            text = text.replace(/-/g, '+').replace(/_/g, '/');
            while (text.length % 4)
                text += '=';

            const binary = atob(text);
            const bytes = Uint8Array.from(binary, char => char.charCodeAt(0));
            return new TextDecoder().decode(bytes);
        };

        // EncAES256
        Vue.prototype.$EncAES256 = function (key_32byte, iv_16byte, text) {

            const key = CryptoJS.enc.Utf8.parse(key_32byte); // 32 characters
            const iv = CryptoJS.enc.Utf8.parse(iv_16byte);   // 16 characters

            const encrypted = CryptoJS.AES.encrypt(text, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            return encrypted.toString()
                .replace(/\+/g, '-')
                .replace(/\//g, '_')
                .replace(/=+$/, '');
        };

        // DecAES256
        Vue.prototype.$DecAES256 = function (key_32byte, iv_16byte, text) {

            let base64 = text.replace(/-/g, '+').replace(/_/g, '/');
            while (base64.length % 4 !== 0) {
                base64 += '=';
            }

            const key = CryptoJS.enc.Utf8.parse(key_32byte);
            const iv = CryptoJS.enc.Utf8.parse(iv_16byte);

            const decrypted = CryptoJS.AES.decrypt(base64, key, {
                iv: iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7
            });

            return decrypted.toString(CryptoJS.enc.Utf8);
        };

        //------------------------------------------[[ Cookie ]]-------------------------------------------

        // SetCookie
        Vue.prototype.$SetCookie = function (name, value, expireMin, domain) {

            const date = new Date();
            if (expireMin > 0) {
                date.setTime(date.getTime() + expireMin * 60 * 1000);
            } else {
                date.setTime(0);
            }

            let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/;`;

            if (expireMin > 0) {
                cookieStr += ` expires=${date.toUTCString()};`;
            }

            if (domain) {
                cookieStr += ` domain=${domain};`;
            }

            document.cookie = cookieStr;
        };

        // GetCookie
        Vue.prototype.$GetCookie = function (name) {

            const nameEQ = `${encodeURIComponent(name)}=`;
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                let c = cookies[i].trim();
                if (c.indexOf(nameEQ) === 0) {
                    const rawValue = c.substring(nameEQ.length);
                    try {
                        return decodeURIComponent(rawValue);
                    } catch (e) {
                        // 디코딩 실패 시 원본 문자열 반환
                        return rawValue;
                    }
                }
            }
            return "";
        };

        // ExtendCookie
        Vue.prototype.$ExtendCookie = (name, extendMin) => {

            // vuex 값
            let value = this.$GetCookie(name);
            if (value) {
                this.setCookie(name, value, extendMin);
                this.printLog(name + " 쿠키의 유효시간이 " + extendMin + "분으로 연장되었습니다.");
            } else {
                this.printLog(name + " 이름을 가진 쿠키를 찾을 수 없습니다.");
            }
        };

        // DelCookie
        Vue.prototype.$DelCookie = function (name, domain) {

            const date = new Date();
            date.setTime(date.getTime() - 1); // 유효기간 과거로 설정하여 삭제
            let cookieStr = `${encodeURIComponent(name)}=; path=/; expires=${date.toUTCString()}`;
            if (domain) {
                cookieStr += `; domain=${domain}`;
            }
            document.cookie = cookieStr;
        };

        // GetRanStrAscii
        Vue.prototype.$GetRanStrAscii = function (letByte) {

            const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            let result = "";
            for (let i = 0; i < letByte; i++) {
                const randomIndex = Math.floor(Math.random() * chars.length);
                result += chars[randomIndex];
            }
            return result;
        };

    },
};
